var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDestino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 22,
    viewBox: "0 0 43 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5002 1C18.4836 1 9.91326 14.6667 4.56543 21.5H40.2176C34.2756 14.3696 24.5169 1 21.5002 1Z",
    fill: "#575757",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0653 21.4998C23.8769 20.6085 14.3697 10.8042 11.6958 10.8042C9.02184 10.8042 5.15953 18.5288 2.78271 21.4998H25.0653Z",
    fill: "#575757",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6089 9.91309C18.5289 9.91309 9.61618 20.6087 9.02197 21.5H33.0872C29.522 17.9348 22.6889 9.91309 20.6089 9.91309Z",
    fill: "#575757",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3045 6.34766C28.6305 6.34766 25.0653 17.0433 23.2827 21.4998H40.2175C38.4349 17.9346 33.9784 6.34766 31.3045 6.34766Z",
    fill: "#575757",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.5H42",
    stroke: "#575757",
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestino);
export default __webpack_public_path__ + "static/media/destino.ccd47f20.svg";
export { ForwardRef as ReactComponent };